const FONTSOURCE_BASE = "https://cdn.jsdelivr.net/fontsource/fonts";

const FONTS: Record<string, string> = {
  Inter: "inter",
  "Crimson Text": "crimson-text",
  "Comic Neue": "comic-neue",
  "Architects Daughter": "architects-daughter",
  "Dancing Script": "dancing-script",
  "Bebas Neue": "bebas-neue",
};

interface Variant {
  weight: number;
  style: string;
  suffix: string;
}

const VARIANTS: Variant[] = [
  { weight: 400, style: "normal", suffix: "400-normal" },
  { weight: 700, style: "normal", suffix: "700-normal" },
  { weight: 400, style: "italic", suffix: "400-italic" },
  { weight: 700, style: "italic", suffix: "700-italic" },
];

let initialized = false;

export function loadFontsForCanvas(): void {
  if (initialized) return;
  initialized = true;

  const rules: string[] = [];

  for (const [family, id] of Object.entries(FONTS)) {
    for (const v of VARIANTS) {
      const url = `${FONTSOURCE_BASE}/${id}@latest/latin-${v.suffix}.woff`;
      rules.push(
        `@font-face {
  font-family: "${family}";
  font-weight: ${v.weight};
  font-style: ${v.style};
  font-display: swap;
  src: url("${url}") format("woff");
}`,
      );
    }
  }

  const style = document.createElement("style");
  style.textContent = rules.join("\n");
  document.head.appendChild(style);

  for (const family of Object.keys(FONTS)) {
    document.fonts.load(`400 16px "${family}"`).catch(() => {});
    document.fonts.load(`700 16px "${family}"`).catch(() => {});
  }
}
